import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import { FiMenu } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { FaLinkedinIn, FaGithub, FaTwitter } from "react-icons/fa";
import { SiFreelancer } from "react-icons/si";
import { logo } from "../../assets/index";
import { navLinksdata } from "../../constants";
import resumePdf from "../../assets/Resume.pdf";
import "./Navbar.css";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    document.body.style.overflow = showMenu ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [showMenu]);

  return (
    <div className="w-full sticky top-3 z-50 mx-auto flex justify-center font-titleFont px-2 pt-2">
      <div className="nav-pill w-full max-w-screen-xl h-16 md:h-18 px-4 md:px-6 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <img
            src={logo}
            alt="logo"
            className="w-9 h-9 rounded-full ring-1 ring-white/10"
          />
        </div>
        <div>
          <ul className="hidden mdl:inline-flex items-center gap-6 lg:gap-8">
            {navLinksdata.map(({ _id, title, link }) => (
              <li
                className="text-sm font-normal text-slate-400 tracking-wide cursor-pointer hover:text-cyan-300 duration-300"
                key={_id}
              >
                <Link
                  activeClass="active"
                  to={link}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  {title}
                </Link>
              </li>
            ))}
          </ul>
          {!showMenu && (
            <button
              type="button"
              aria-label="Open menu"
              onClick={() => setShowMenu(true)}
              className="text-xl mdl:hidden bg-slate-950 border border-white/10 w-10 h-10 inline-flex items-center justify-center rounded-full text-designColor cursor-pointer"
            >
              <FiMenu />
            </button>
          )}
        </div>
      </div>

      {showMenu && (
        <div className="fixed inset-0 z-[100] mdl:hidden">
          <button
            type="button"
            aria-label="Close menu backdrop"
            className="absolute inset-0 bg-slate-950/80 backdrop-blur-sm"
            onClick={() => setShowMenu(false)}
          />
          <aside className="mobile-drawer absolute top-0 left-0 h-full w-[min(88vw,22rem)] flex flex-col overflow-y-auto border-r border-white/10 shadow-2xl">
            <div className="flex items-start justify-between gap-4 p-5 pb-2">
              <img
                className="w-16 h-16 rounded-full object-cover ring-1 ring-white/15"
                src={logo}
                alt="logo"
              />
              <button
                type="button"
                aria-label="Close menu"
                onClick={() => setShowMenu(false)}
                className="w-10 h-10 shrink-0 inline-flex items-center justify-center rounded-full bg-slate-900 border border-white/10 text-slate-300 hover:text-cyan-300 duration-300 text-2xl"
              >
                <MdClose />
              </button>
            </div>

            <div className="px-5 pb-4">
              <p className="text-sm leading-relaxed text-slate-400">
                Full Stack Developer · React.js · Node.js · NestJS · TypeScript
                · PostgreSQL · AWS
              </p>
            </div>

            <nav className="px-3 pb-6">
              <ul className="flex flex-col gap-1">
                {navLinksdata.map((item) => (
                  <li key={item._id}>
                    <Link
                      onClick={() => setShowMenu(false)}
                      activeClass="active"
                      to={item.link}
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                      className="block rounded-xl px-3 py-3 text-base font-normal text-slate-300 tracking-wide cursor-pointer hover:bg-white/5 hover:text-cyan-300 duration-300"
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="mt-auto px-5 pb-8 pt-2 border-t border-white/10">
              <h2 className="text-xs uppercase font-titleFont tracking-[0.2em] mb-4 text-slate-400 font-mono">
                Find me in
              </h2>
              <div className="flex flex-wrap gap-3">
                <a
                  href="https://github.com/chandramouli35"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bannerIcon"
                >
                  <FaGithub />
                </a>
                <a
                  href="https://www.linkedin.com/in/mouli-chandra/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bannerIcon"
                >
                  <FaLinkedinIn />
                </a>
                <a
                  href="https://x.com/Chandra37006776"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bannerIcon"
                >
                  <FaTwitter />
                </a>
                <a
                  href="https://www.freelancer.in/u/Chandramouli1m"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bannerIcon"
                >
                  <SiFreelancer />
                </a>
              </div>
            </div>
          </aside>
        </div>
      )}

      {!showMenu && (
        <a
          href={resumePdf}
          download="ChandraMouli_FullStack_Resume.pdf"
          className="fixed bottom-4 right-4 z-50 btn-primary-agi font-bold py-2.5 px-5 rounded-full transition duration-300 animate-glow"
        >
          Download Resume
        </a>
      )}
    </div>
  );
};

export default Navbar;
